import { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import Loading from "./LoadingComponent";
import ErrorComponent from "./ErrorComponent";
import useFetchBlogPosts from "../custom_hook/useFetchBlogPosts";
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";
import ReactMarkdown from "react-markdown";
import remarkMath from "remark-math";
import rehypeKatex from "rehype-katex";

const getFirstTwentyWords = (content: string) => {
  // Remove image syntax ![alt](url)
  const noImages = content.replace(/!\[.*?\]\(.*?\)/g, "");

  // Remove inline code `code`
  const noInlineCode = noImages.replace(/`[^`]*`/g, "");

  // Remove bold/italic: **bold**, *italic*, __bold__, _italic_
  const noFormatting = noInlineCode.replace(/(\*\*|__|\*|_)/g, "");

  // Remove headers #### Header
  const noHeaders = noFormatting.replace(/^#+\s?/gm, "");

  // Remove blockquotes >
  const noBlockquotes = noHeaders.replace(/^>\s?/gm, "");

  // Remove links but keep link text: [text](url) → text
  const noLinks = noBlockquotes.replace(/\[(.*?)\]\(.*?\)/g, "$1");

  // Remove any extra markdown leftovers
  const plainText = noLinks.replace(/[*`_>#+\-]/g, "");

  // Extract words
  const words = plainText.trim().split(/\s+/);

  // Return first 20 words joined back
  return words.slice(0, 20).join(" ") + "...";
};

const BlogPostList = () => {
  const { posts, error, isLoading } = useFetchBlogPosts();

  const navigate = useNavigate();

  const [searchQuery, setSearchQuery] = useState<string>("");
  const filteredPosts = useMemo(() => {
    return posts.filter((post) =>
      post.title.toLowerCase().startsWith(searchQuery.toLowerCase())
    );
  }, [posts, searchQuery]);

  const handleClick = (postId: number) => {
    navigate(`/blogposts/${postId}`);
  };

  if (isLoading) {
    return <Loading />;
  }

  if (error) {
    return <ErrorComponent message={error.message} />;
  }

  return (
    <>
      <div className="search-container">
        <div className="mb-3">
          <input
            className="form-control"
            id="post-search"
            name="post-search"
            placeholder="Search"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>
      </div>
      <div className="container bg-dark">
        <div className="blog-list-container">
        {filteredPosts.map((post) => (
          <div key={post.id} className="blogpost-card">
            <img
                src={post.cover_image}
                alt="cover image"
              />
            <div
              className="summary-container grid-span-col-2"
              onClick={() => {
                handleClick(post.id);
              }}
            >
              <div
              className="blog-title-container"
              onClick={() => {
                handleClick(post.id);
              }}
            >
              {post.title}
            </div>
              <div className="blog-summary">
                <ReactMarkdown
                  children={getFirstTwentyWords(post.content)}
                  remarkPlugins={[remarkGfm, remarkMath]}
                  rehypePlugins={[rehypeRaw, rehypeKatex]}
                />
              </div>
            </div>
            
          </div>
        ))}
        </div>
      </div>
    </>
  );
};

export default BlogPostList;
